export default ({
  fillCircleColor = '#118906',
  fillCheckColor = '#FFFFFF',
  ...props
}) => (
  <svg {...props} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <g fill="none">
      <path d="M0 0h20v20H0z" />
      <path d="M10 2a8 8 0 100 16 8 8 0 000-16z" fill={fillCircleColor} />
      <path d="M4 4h12v12H4z" />
      <path
        d="M8.837 13a.6.6 0 01-.421-.173l-2.438-2.4a.6.6 0 11.843-.854l2.012 1.98 4.341-4.377a.6.6 0 11.851.847l-4.762 4.8a.601.601 0 01-.426.177"
        fill={fillCheckColor}
      />
    </g>
  </svg>
);
